// extracted by mini-css-extract-plugin
export default {"heading":"TB-z","corrected":"UB-z","redirectVerbiageContainer":"VB-z","redirectVerbiageText":"WB-z"};